<template>
  <div class="full_width">
    <v-btn class="refresh-button" @click="refreshOrders">
      <v-icon color="#6E6E6E">mdi-sync</v-icon>
    </v-btn>
    <div class="table-style">
      <div class="table-header">
        <div class="pill-radio-buttons-div">
          <v-text-field
            v-model="searchValue"
            rounded
            outlined
            dense
            full-width
            prepend-inner-icon="mdi-magnify"
            label="Suche"
            single-line
            hide-details
            @input="searchOrders"
          />
        </div>
      </div>

      <div v-if="serverError">
        <h1>{{ $t('order_details.loading_error') }}</h1>
        <p>{{ $t('order_details.error_hint') }}</p>
      </div>
      <v-data-table
        v-else
        disable-sort
        :headers="headers"
        :items="orders"
        item-key="orderId"
        :loading="loading"
        :loading-text="$t('overview_table.loading_text')"
        :no-data-text="
          isDataLoaded
            ? $t('overview_table.no_filter_data')
            : $t('overview_table.error_data')
        "
        :footer-props="{ 'items-per-page-options': [10] }"
        :server-items-length="orderCount"
        :options.sync="options"
        :page="currentPage"
        calculate-widths
      >
        <template v-slot:[`item.date`]="{ item }">
          <span v-if="item.date">
            {{ item.date | formatDate('DD.MM.YYYY HH:mm') }}
          </span>
          <span v-else>-</span>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
import { getCommissioningOrdersWithFilter } from '../../services/CommissioningService';
import { getSealingTableConfig } from './sealingTableConfig';
import { sealingTableOrderMapper } from './transformRawSealingOrder';

const SEALING_JOURNEY_TYPE = 'SEALING_ELECTRICITY_ORDER';

export default {
  name: 'SealingOverviewTable',
  data() {
    return {
      currentPage: this.$route.query.page
        ? parseInt(this.$route.query.page, 10)
        : 1,
      searchValue: this.$route.query.search || '',
      orders: [],
      orderCount: 0,
      options: {},
      loading: false,
      isDataLoaded: false,
      serverError: false,
      headers: getSealingTableConfig('headers'),
    };
  },
  watch: {
    searchValue(value) {
      this.updateURLParam('search', value);
    },
    options: {
      deep: true,
      handler(value) {
        this.currentPage = value.page;
        this.updateURLParam('page', value.page);
        this.loadOrders();
      },
    },
  },
  created() {
    this.loadOrders();
  },
  methods: {
    updateURLParam(name, value) {
      const params = { ...this.$route.query };
      if (!value || value === 'all') delete params[name];
      else params[name] = value;
      history.replaceState(
        {},
        null,
        `${this.$route.path}?${new URLSearchParams(params)}`
      );
    },
    refreshOrders() {
      this.searchValue = '';
      this.currentPage = 1;
      history.replaceState({}, null, `${this.$route.path}?page=1`);
      this.loadOrders();
    },
    searchOrders(value) {
      if (value.length === 0 || value.length > 2) {
        this.currentPage = 1;
        this.loadOrders();
      }
    },
    async loadOrders() {
      this.loading = true;
      try {
        const response = await getCommissioningOrdersWithFilter({
          limit: 10,
          from_index: (this.currentPage - 1) * 10,
          journey_type: SEALING_JOURNEY_TYPE,
          search_word: this.searchValue,
        });

        this.orderCount = response?.count_orders || 0;
        this.orders = (response?.items || []).map(sealingTableOrderMapper);
        this.serverError = false;
        this.isDataLoaded = true;
      } catch (error) {
        console.error('Error fetching sealing orders:', error);
        this.orders = [];
        this.orderCount = 0;
        this.serverError = true;
        this.isDataLoaded = false;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
